import { render } from "./WavyChart.vue?vue&type=template&id=5da21ebc"
import script from "./WavyChart.vue?vue&type=script&lang=js"
export * from "./WavyChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__